import { AccesosEffects } from './accesos.effects';
import { AuthEffects } from './auth.effects';
import { MenuEffects } from './menu.effects';

export const EffectsArray: any[] = [AccesosEffects, MenuEffects, AuthEffects];
